import PlainHtmlArticleSection from './PlainHtmlArticleSection';

export default PlainHtmlArticleSection;
